package com.milta.core.localization.translations.it

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abbonamento scaduto",
    driverSoloMessage = "Il tuo abbonamento è scaduto. Rinnova per continuare.",
    patronMessage = "Il tuo abbonamento è scaduto. Il tuo team non può più accedere a Milta.",
    driverUnderPatronMessage = "L'abbonamento della tua organizzazione è scaduto. Contatta la tua organizzazione per ripristinare l'accesso.",
    renewButton = "Rinnova",
    close = "Chiudi",
    subscribeButtonTemplate = "Abbonati per %s",
)
